<div class="relative h-full w-full">
  @if (hasScrollableViewport) {
    <div class="absolute -top-[44px] right-0 z-[3] flex items-center gap-2 rounded-lg border border-line bg-card/95 px-2 py-1 shadow-sm backdrop-blur-sm">
      <button type="button" class="flex h-6 w-6 items-center justify-center rounded-md text-muted hover:bg-primary-bg hover:text-primary disabled:opacity-35" [disabled]="!canMoveOlder" (click)="moveViewport('older')" aria-label="Show previous month"><i class="pi pi-chevron-left text-[10px]"></i></button>
      <span class="min-w-[145px] text-center text-[10px] font-semibold text-dim">{{ viewportLabel }}</span>
      <button type="button" class="flex h-6 w-6 items-center justify-center rounded-md text-muted hover:bg-primary-bg hover:text-primary disabled:opacity-35" [disabled]="!canMoveNewer" (click)="moveViewport('newer')" aria-label="Show next month"><i class="pi pi-chevron-right text-[10px]"></i></button>
    </div>
  }
<div
  #chartContainer
  echarts
  [options]="options"
  (chartInit)="onChartInit($event)"
  class="w-full h-full"
></div>
</div>
